// extracted by mini-css-extract-plugin
module.exports = {"Part4":"Part4_Part4__6gQ7H","Part5":"Part4_Part5__ji3zQ","Part6":"Part4_Part6__96rsu","Part7":"Part4_Part7__iHThK","Part8":"Part4_Part8__oS9vZ"};